import { render } from "./MainOverlay.vue?vue&type=template&id=3381901b&scoped=true"
import script from "./MainOverlay.vue?vue&type=script&lang=js"
export * from "./MainOverlay.vue?vue&type=script&lang=js"

import "./MainOverlay.vue?vue&type=style&index=0&id=3381901b&lang=scss&scoped=true"

import exportComponent from "/Users/benjamin_nalo/Ben/portfolio-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3381901b"]])

export default __exports__